import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { SnackBarData } from 'src/app/shared/components/snack-bar/snack-bar-data';

@Component({
  selector: 'app-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss'],
  standalone: false
})
export class SnackBarComponent {
  data = inject<SnackBarData>(MAT_SNACK_BAR_DATA);

  constructor() { }
}
